import { render, staticRenderFns } from "./AttachmentInforme.vue?vue&type=template&id=3b599ee6&scoped=true&"
import script from "./AttachmentInforme.vue?vue&type=script&lang=js&"
export * from "./AttachmentInforme.vue?vue&type=script&lang=js&"
import style0 from "./AttachmentInforme.vue?vue&type=style&index=0&id=3b599ee6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b599ee6",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib'
import { VFlex } from 'vuetify/lib'
import { VIcon } from 'vuetify/lib'
import { VLayout } from 'vuetify/lib'
import { VSwitch } from 'vuetify/lib'
installComponents(component, {
  VBtn,
  VFlex,
  VIcon,
  VLayout,
  VSwitch,
})
